const nameRules = [v => !!v || 'Name is required'];
const descriptionRules = [v => !!v || 'Description is required',
(v) => v.length<200 ? true : "This field is a maximum of 200 characters long."
]
const locationRules = [
    v => !!v || 'Location is required'
]

const waypointsRules = [
  async file => {
    if (!file) return 'Debe seleccionar un archivo';

    if (!file.name.endsWith('.json')) {
      return 'El archivo debe tener extensión .json';
    }

    try {
      const text = await file.text();
      const json = JSON.parse(text);

      if (!Array.isArray(json)) {
        return 'El archivo debe contener un array de objetos';
      }

      for (const [index, item] of json.entries()) {
        if (typeof item !== 'object') {
          return `La entrada #${index + 1} no es un objeto válido`;
        }

        const requiredArrayFields = ['nodes', 'latitudes', 'longitudes'];
        for (const field of requiredArrayFields) {
          if (!Array.isArray(item[field])) {
            return `El campo "${field}" en la entrada #${index + 1} debe ser un array`;
          }
        }

        // Validar tipos básicos
        if (
          typeof item.id !== 'number' ||
          typeof item.mission_id !== 'number' ||
          typeof item.is_cyclic !== 'number' ||
          typeof item.vehicle_id !== 'number'
        ) {
          return `Los campos id, mission_id, is_cyclic y vehicle_id deben ser numéricos (error en entrada #${index + 1})`;
        }

        // ✅ Validación del timestamp
        if (
          typeof item.timestamp !== 'string' ||
          isNaN(Date.parse(item.timestamp))
        ) {
          return `El campo "timestamp" en la entrada #${index + 1} no es una fecha válida`;
        }
      }

      return true;
    } catch (err) {
      return 'El archivo no contiene JSON válido';
    }
  }
];



export {
    nameRules,locationRules,descriptionRules,waypointsRules
}